class ComponentForm {
  constructor() {
    this._init();
  }

  _init() {
    document.querySelectorAll<HTMLInputElement>('form input, form textarea').forEach((input) => {
      input.addEventListener('focus', () => {
        input.closest('.contact-form__item')?.classList.add('focused');
      });

      input.addEventListener('blur', () => {
        if (input.value.trim() === '') {
          input.classList.remove('filled');
          input.closest('.contact-form__item')?.classList.remove('focused');
        } else {
          input.closest('.contact-form__item')?.classList.remove('filled');
        }
      });
    });

    // 1. Démarrage : On utilise l'événement natif 'submit'
    // (Car 'wpcf7submit' se déclenche souvent APRÈS l'envoi, ce qui est trop tard pour le loading)
    document.addEventListener('submit', (event: Event) => {
      const form = event.target as HTMLFormElement;

      // On vérifie que c'est bien un formulaire CF7 et qu'il existe
      if (!form || !form.classList.contains('wpcf7-form')) return;

      const spinner = form.querySelector('.wpcf7-spinner') as HTMLElement | null;
      if (spinner) {
        spinner.classList.add('is-active');
      }

      const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement | null;
      if (btn) {
        btn.disabled = true;
      }
    }, false);

    // 2. Fin : Réception de la réponse (Succès ou Erreur)
    const cf7Events: string[] = ['wpcf7invalid', 'wpcf7spam', 'wpcf7mailsent', 'wpcf7mailfailed'];

    cf7Events.forEach((eventName) => {
      document.addEventListener(eventName, (event: Event) => {
        const form = event.target as HTMLFormElement;
        if (!form) return;

        const spinner = form.querySelector('.wpcf7-spinner') as HTMLElement | null;
        if (spinner) {
          spinner.classList.remove('is-active');
        }

        const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement | null;
        if (btn) {
          btn.disabled = false;
        }
      }, false);
    });

  }
}

export const componentForm = new ComponentForm();
